import * as React from "react";
import CssBaseline from "@mui/material/CssBaseline";
import Container from "@mui/material/Container";
import Paper from "@mui/material/Paper";
import Link from "@mui/material/Link";
import Typography from "@mui/material/Typography";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";
import { FormikProvider, Form, useFormik, ErrorMessage } from "formik";
import * as Yup from "yup";
import Button from "@mui/material/Button";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { studyPackUserSignUp } from "../../../../apiCalls/userApiCalls";
import {
  errNotification,
  successNotification,
} from "../../../common/notification";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const theme = createTheme();

export default function StudyPackRegModel() {
  const navigate = useNavigate();
  const [loading, setLoading] = React.useState(false);

  const validationSchema = Yup.object().shape({
    password: Yup.string().min(4).required("Please is required"),
    email: Yup.string().email("Email is invalid").required("Email is required"),
    phone: Yup.string().min(10).required("Phone Number is required"),
  });

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
      username: "",
      phone: "",
    },
    validationSchema,
    onSubmit: async (values, { resetForm }) => {
      try {
        const payload = {
          email: values.email,
          password: values.password,
          username: values.username,
          phone: values.phone,
        };
        console.log(payload);
        setLoading(true);
        studyPackUserSignUp(payload)
          .then((res) => {
            setLoading(false);
            successNotification("Regitered successfully !!!");
          })
          .catch((err) => {
            setLoading(false);
            errNotification("Regitered Process Failed !!!");
          });

        resetForm();
      } catch (error) {
        console.log(error);
      }
    },
  });

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Container component="main" maxWidth="sm">
        <Paper
          variant="outlined"
          sx={{
            my: { xs: 3, md: 6 },
            p: { xs: 2, md: 3 },
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
          }}
        >
          <Typography
            component="h1"
            variant="h5"
            sx={{
              textAlign: "center",
              marginBottom: "10px",
            }}
          >
            Register For Study Pack
          </Typography>

          <React.Fragment>
            <FormikProvider value={formik}>
              <Form onSubmit={formik.handleSubmit}>
                <React.Fragment>
                  <Grid container spacing={3}>
                    <Grid item xs={12} md={12}>
                      <TextField
                        id="email"
                        label="Email"
                        fullWidth
                        variant="standard"
                        name="email"
                        autoCapitalize="off"
                        onChange={formik.handleChange}
                        value={formik.values.email}
                      />
                      <ErrorMessage name="email">
                        {(msg) => (
                          <div
                            style={{
                              color: "red",
                              textAlign: "left",
                              fontSize: "12px",
                            }}
                          >
                            {msg}
                          </div>
                        )}
                      </ErrorMessage>
                    </Grid>
                    <Grid item xs={12} md={12}>
                      <TextField
                        id="username"
                        label="Username"
                        fullWidth
                        variant="standard"
                        name="username"
                        autoCapitalize="off"
                        onChange={formik.handleChange}
                        value={formik.values.username}
                      />
                      <ErrorMessage name="username">
                        {(msg) => (
                          <div
                            style={{
                              color: "red",
                              textAlign: "left",
                              fontSize: "12px",
                            }}
                          >
                            {msg}
                          </div>
                        )}
                      </ErrorMessage>
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <TextField
                        id="phone"
                        label="Phone Number ( Whatsapp )"
                        fullWidth
                        placeholder="Ex-0776631523"
                        variant="standard"
                        name="phone"
                        autoCapitalize="off"
                        onChange={formik.handleChange}
                        value={formik.values.phone}
                      />
                      <ErrorMessage name="phone">
                        {(msg) => (
                          <div
                            style={{
                              color: "red",
                              textAlign: "left",
                              fontSize: "12px",
                            }}
                          >
                            {msg}
                          </div>
                        )}
                      </ErrorMessage>
                    </Grid>

                    <Grid item xs={12} md={12}>
                      <TextField
                        id="password"
                        label=" password"
                        fullWidth
                        variant="standard"
                        type="password"
                        name="password"
                        autoComplete="off"
                        onChange={formik.handleChange}
                        value={formik.values.password}
                      />
                      <ErrorMessage name="password">
                        {(msg) => (
                          <div
                            style={{
                              color: "red",
                              textAlign: "left",
                              fontSize: "12px",
                            }}
                          >
                            {msg}
                          </div>
                        )}
                      </ErrorMessage>
                    </Grid>
                  </Grid>

                  <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                    <Button
                      variant="contained"
                      sx={{ mt: 3, ml: 1 }}
                      width="100px"
                      type="submit"
                      disabled={loading || !formik.isValid}
                    >
                      submit
                    </Button>
                  </Box>
                </React.Fragment>
              </Form>
            </FormikProvider>
          </React.Fragment>
        </Paper>
      </Container>
    </ThemeProvider>
  );
}
